export default __webpack_public_path__ + "img/tablet.f6f71f1e.svg";